<script lang="ts" setup>
import { ProjectModel } from "@/models";
import { onBeforeMount, PropType, ref } from "vue";
import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmInput } from "tir-components";
import { TaskParameterTypeEnum } from "../task-parameter";
import { ChevronDownIcon, CheckIcon } from "tir-style-system/icons/outline";
import { AdapterService } from "./adapter-service";
import {
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
  Squares2X2Icon,
} from "tir-style-system/icons/outline";
/**API сервис */
const apiService = new AdapterService();

/**Параметры */
defineProps({
  modelValue: { type: Object as PropType<ProjectModel> },
  /**Тип проекта */
  type: { type: Number as PropType<TaskParameterTypeEnum> },

});
/**События */
const emit = defineEmits<{
  /**Выбор проекта */
  "update:modelValue": [project: ProjectModel];
}>();

/**Список проектов */
const projects = ref<ProjectModel[]>([]);

/**Перед рендером */
onBeforeMount(() => getProjects());

/**Получить список проектов */
const getProjects = async (value: string = "") => {
  const response = await apiService.GetProjects(value);
  if (response.IsSuccess) projects.value = response.Value;
};

/**Выбор проекта */
const selectProject = (project: ProjectModel) => {
  getProjects();
  emit("update:modelValue", project);
};
</script>
<template>
  <TirPmDropdown
    class="choose-project-dropdown"
    width="16rem"
    popoverWidth="16rem"
    :options="projects"
    showOnHover
    :size="TirPmDropdownSizeEnum.Light"
    :selected-option="modelValue"
    :isSearchLocal="false"
    :isHiddenSearch="false"
    @updateSearch="getProjects"
    optionListScrollHeight="24rem"
  >
    <template #target="slot">
      <div class="choose-project-dropdown_target">
        <div class="dd-project-icon">
          <Squares2X2Icon />
        </div>

        <div v-if="!modelValue">Выбор проекта</div>
        <template v-else>
          <TirPmIconView
            :is-bordered="false"
            :is-rounded="true"
            :size="24"
            :colorCode="modelValue.PreviewColor"
            :image-load-url="modelValue.ImageUrl"
          >
            <template #mainSlot>
              {{ modelValue.Name[0]?.toLocaleUpperCase() }}
            </template>
          </TirPmIconView>
          <div class="choose-project-dropdown_text">
            {{ modelValue.Name }}
          </div>
        </template>
        <ChevronDownIcon
          class="choose-project-dropdown_target_arrow"
          :class="{ open: slot.isOpened }"
        />
      </div>
    </template>
    <template #optionList="slot">
      <div
        class="choose-project-dropdown_option"
        :class="{ selected: modelValue?.Id == slot.option.Id }"
        @click="selectProject(slot.option)"
      >
        <TirPmIconView
          :is-bordered="false"
          :is-rounded="true"
          :size="24"
          :colorCode="slot.option.PreviewColor"
          :image-load-url="slot.option.ImageUrl"
        >
          <template #mainSlot>
            {{ slot.option.Name[0]?.toLocaleUpperCase() }}
          </template>
        </TirPmIconView>
        <div class="choose-project-dropdown_text">
          {{ slot.option.Name }}
        </div>
        <!-- <CheckIcon class="choose-project-dropdown_option_check" /> -->
      </div>
    </template>
  </TirPmDropdown>
</template>
<style lang="scss">
.choose-project-dropdown {
  margin-bottom: 1rem;

  .dd-project-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
  }

  &.tir-pm-dropdown {
    width: 100% !important;
  }

  &_text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &_target {
    position: relative;
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0 2rem 0 0.75rem;
    background: var(--neutral-translucent-20);
    border-radius: 0.375rem;
    color: var(--text-primary, #272d37);
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    &_arrow {
      position: absolute;
      top: 50%;
      right: 0.75rem;
      transform: translateY(-50%);
      width: 1rem;
      height: 1rem;
      transition: 0.2s linear;

      &.open {
        transform: translateY(-50%) rotate(-180deg);
      }
    }
  }

  .tir-pm-dropdown__label.light {
    display: none;
  }

  &_option {
    position: relative;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0 0.75rem;
    transition: 0.2s linear;
    cursor: pointer;

    &:hover,
    &.selected {
      background: var(--neutral-translucent-5);
    }

    &_check {
      display: none;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.75rem;
      width: 1.5rem;
      height: 1.5rem;
    }

    &.selected {
      .choose-project-dropdown_option_check {
        display: block;
      }
    }
  }
}
</style>
